import anime from "animejs"

export default () => ({
    open: false,
    infoModalOpen:false,

    init() {
        
    },


    async onInfoModalClosed(){
        this.infoModalOpen = false;
        anime({
            targets: this.$refs.button,
            rotate: '0deg',
            duration: 550
        });
    },


    async onInfoModalOpen(){
        this.infoModalOpen = true;
        anime({
            targets: this.$refs.button,
            rotate: '45deg',
            duration: 550
        });

    },




    /**
   * Transitions to open mobile menu from closed state.
   */
    async onOpenMenu() {
        
        if(this.infoModalOpen){
            window.dispatchEvent(new CustomEvent('close-info-modal'));
            return;
        }

        if (this.open == true) {
            this.hide();

        } else {
            this.open = true;
            this.show();

        }
    },
    async show() {
        
        await anime({
            targets: this.$refs.menu,
            translateX: '-100vw',
            opacity: 0,
            duration: 0
        }).finished;

        anime({
            targets: this.$refs.button,
            rotate: '45deg',
            duration: 550
        });

        const tl = anime.timeline({
            easing: 'easeOutQuint',
            duration: 0
        });

        tl.add({
            targets: this.$refs.menu,
            translateX: '0vw',
            duration: 0,
        })
        tl.add({
            targets: this.$refs.menu,
            opacity: 1,
            duration: 200,
        })
            .add({
                targets: '.m-mobileMenu__list li',
                opacity: [0, 1],
                translateX: ['-30px', 0],
                duration: 1000,
                delay: anime.stagger(100, { direction: 'reverse' }),
            }, 250)
    },
    /**
   * Transitions to close mobile menu from open state.
   */
    async hide() {

        anime({
            targets: '#openbutton',
            rotate: '0deg',
            duration: 500
        });

        const tl = anime.timeline({
            easing: 'easeOutQuint',
            duration: 0
        })

            .add({
                targets: '.m-mobileMenu__list li',
                translateX: ['0px', '-30px'],
                delay: anime.stagger(100),
                opacity: 0,
                easing: 'easeInQuint',
                duration: 500,
            })


            .add({
                targets: '.m-mobileMenu',
                opacity: '0',
                easing: "easeInQuint",
                duration: 500
            }, 500)

        await tl.finished;


        this.open = false;
    },

})